export default __webpack_public_path__ + "static/media/Familiarization-Programme-for-Independent-Directors_STL.a8ed8606.pdf";